import styled from 'styled-components';

export const Container = styled.div`
  max-width: 1440px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 0 50px;

  @media (max-width: 970px) {
    justify-content: center;
  }

  @media (max-width: 1396px) {
    justify-content: space-around;
  }
`;

export const Section = styled.div`
  display: flex;
  background: linear-gradient(273.21deg, #152d7c 2.3%, #1e3faa 94.49%);
  box-shadow: 0px 2px 15px rgba(100, 114, 140, 0.25);
  border-radius: 25px;
  max-width: 1430px;
  height: 460px;
  margin: 140px auto;
  margin-top: 140px;

  & > div {
    width: 50%;
  }

  form {
    label {
      font-family: 'Montserrat';
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 20px;
      color: #FFFFFF;
    }
  }

  p, span {
    font-family: 'Montserrat';
    color: white;
    font-size: 32px;
    font-weight: bold;
  }

  button {
    height: 40px;
    border: none;
    cursor: pointer;
    color: #2253f5 !important;
    background: rgb(252, 255, 124) !important;
    border-radius: 100px !important;
    padding-left: 30px !important;
    padding-right: 30px !important;
    font-family: Montserrat !important;
    font-weight: bold !important;
    font-size: 16px !important;
  }

  h1 {
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 700;
    font-size: 32px;
    line-height: 39px;
    color: #ffffff;
  }

  @media (max-width:762px) {
    flex-direction: column;
    height: auto;
    padding: 30px;
    padding-bottom: 0;
    max-width: 348px;


    p, span {
      font-size: 24px;
    }


    h1 {
      font-family: 'Montserrat';
      font-style: normal;
      font-weight: 700;
      font-size: 24px;
      line-height: 29px;
    }

    button {
      display: block;
      width:280px;
      margin: 0 auto;
    }
    
    div.image {
      width: 100% !important;
      margin: 0 !important;
      margin-top: 20px !important;
      margin-bottom: -4px !important;
    }

    div.text {
      width: 100% !important;
      padding: 0 !important;
    }
  }
`;

export const Wrapper = styled.div`
  background: #2253f5;
  color: #ffffff;

  font-family: 'Montserrat', sans-serif;
  h1,
  h2,
  h3,
  p {
    margin: 0;
  }

  div.hero-1 {
    max-width: 750px;
    text-align: center;
    margin: 0 auto;
    padding-top: 125px;

    h1 {
      font-size: 48px;
      line-height: 56px;
    }

    p {
      max-width: 620px;
      margin: 30px auto;

      font-family: Source Sans Pro;
      font-weight: 300;
      font-size: 24px;
      line-height: 32px;

      color: #ffffff;
    }

    @media (max-width: 768px) {
      max-width: 320px;
      padding-top: 40px;

      h1 {
        font-size: 24px;
        line-height: 32px;
      }

      p {
        max-width: 300px;
        margin: 20px auto;

        font-size: 16px;
        line-height: 24px;
      }
    }
  }

  .containerSlider {
    background: linear-gradient(278.18deg, #2253f5 0%, #36a0fc 99.04%);
    box-shadow: 0px 2px 15px rgba(100, 114, 140, 0.25);

    .sliderLogo {
      max-width: 1500px;
      margin: 0 auto;

      padding: 20px 0;

      img {
        height: 50px;
      }


      .regular {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 70px;
      };

      .cloudezMidia {
      display: flex;
      align-items: center;
      justify-content: center;

      a {
        height: 33px;
      }
      }

      a {
        width: auto !important;
      }
      }
  }

  
  

  div.apps {
    width: 100%;
    height: 200px;
    background: url('/iconeshome.png') center repeat-x;

    @media (max-width: 768px) {
      height: 210px;
    }
  }

  main {
    margin-top: 150px;

    @media (max-width: 768px) {
      margin: 0;
    }

    section.section {
      display: flex;
      max-width: 1440px;
      margin: 0 auto;
      justify-content: space-around;
      position: relative;
      z-index: 2;

      div {
        height: 100%;
        /* width: 50%; */
        text-align: start;
      }

      div.text {
        width: 570px;
      }

      div.img {
     
      }

      h1 {
        font-size: 40px;
        line-height: 48px;
      }

      p {
        margin-top: 20px;
        font-family: Source Sans Pro;
        font-style: normal;
        font-weight: 300;
        font-size: 18px;
        line-height: 24px;

        color: #ffffff;
      }

      @media (min-width: 769px) and (max-width: 1250px) {
        margin: 0 !important;
        flex-direction: column;
        align-items: center;

        div.text {
          margin: 0 !important;
          margin-bottom: 30px !important;
          width: 750px;
          text-align: center;
        }

        img {
          margin: 0 !important;
          max-width: 100% !important;
        }
      }

      @media (max-width: 768px) {
        margin: 0 !important;
        flex-direction: column;
        align-items: center;

        div {
          width: 70%;
        }

        div.text {
          margin: 0 !important;
          width: unset !important;
          text-align: center;

          h1 {
            max-width: 310px;
            margin: 0 auto;
            font-size: 20px;
            line-height: 24px;
          }

          p {
            max-width: 320px;
            margin: 20px auto;
            font-weight: 300;

            font-size: 16px;
            line-height: 24px;
          }
        }
      }
    }

    div.background {
      position: relative;
      height: 5410px;
      width: 100%;

      text-align: center;

      div.divbackground {
          width: 100%;
          max-width: 1440px;
          height: 5410px;
          margin: 0 auto;
          position: absolute;
          top: 0;
          left: calc(50% - 720px);

          @media (max-width: 1250px) {
            display: none;
          }
      }

      @media (max-width: 1250px) {
        background: none;
        height: auto;
      }
    }

    div.hero {
      max-width: 750px;
      text-align: center;
      margin: 0 auto;
      padding-top: 40px;
      position: relative;
      z-index: 3;

      h1 {
        color: #fcff7c;
        font-size: 40px;
        line-height: 48px;
      }

      p {
        max-width: 550px;
        margin: 10px auto;
        font-family: 'Source Sans Pro', sans-serif;
        font-weight: 300;
        font-size: 18px;
        line-height: 24px;
      }

      @media (min-width: 769px) and (max-width: 1250px) {
        padding-bottom: 40px;
      }

      @media (max-width: 768px) {
        max-width: 290px;

        h1 {
          font-size: 20px;
          line-height: 24px;
        }

        p {
          max-width: 3000px;
          margin: 27px auto;

          font-size: 16px;
          line-height: 24px;
        }
      }
    }

    .mobile-step1 {
      width: 67px;
      height: 116px;
      margin: 10px auto;

      @media (min-width: 769px) and (max-width: 1250px) {
        width: 130px;
        height: 225px;
      }

      @media (min-width: 1250px) {
        display: none;
      }
    }

    .mobile-step2 {
      width: 67px;
      height: 227px;
      margin: 10px auto;

      @media (min-width: 769px) and (max-width: 1250px) {
        width: 130px;
        height: 435px;
      }

      @media (min-width: 1250px) {
        display: none;
      }
    }

    .mobile-step3 {
      width: 67px;
      height: 229px;
      margin: 10px auto;

      @media (min-width: 769px) and (max-width: 1250px) {
        width: 130px;
        height: 435px;
      }

      @media (min-width: 1250px) {
        display: none;
      }
    }

    .mobile-step4 {
      width: 67px;
      height: 229px;
      margin: 10px auto;

      @media (min-width: 769px) and (max-width: 1250px) {
        width: 130px;
        height: 435px;
      }

      @media (min-width: 1250px) {
        display: none;
      }
    }

    .mobile-step5 {
      width: 67px;
      height: 229px;
      margin: 10px auto;

      @media (min-width: 769px) and (max-width: 1250px) {
        width: 130px;
        height: 435px;
      }

      @media (min-width: 1250px) {
        display: none;
      }
    }
  }

  .section-posts {
    width: 100%;
    background: #fff;
    font-family: Montserrat;

    h1 {
      display: flex;
      justify-content: center;
      font-size: 3rem;
      font-weight: bold;
      color: #333;
      padding-top: 53px;
      margin-bottom: 83px;
    }

    .post {
      display: flex;
      max-width: 1200px;
      margin: 0 auto;
      padding-left: 62px;
      gap: 76px;

      .cardblog {
        width: 316px;
        height: 434px;
        background: #fff;
        box-shadow: 0px 3.67108px 14.6843px rgba(0, 0, 0, 0.15);
        border-radius: 11.0132px;
        margin-bottom: 120px;
        overflow: hidden;

        img {
          width: auto;
          height: auto;
          display: block;
          object-fit: cover;
          cursor: pointer;
          transition: 0.75s;
        }

        img:hover {
          transform: scale(1.2);
        }
      }

      .cardblog-stamp {
        width: 316px;
        height: 434px;
        background: #fff;
        box-shadow: 0px 3.67108px 14.6843px rgba(0, 0, 0, 0.15);
        border-radius: 11.0132px;
        margin-bottom: 120px;
        overflow: hidden;

        img {
          width: auto;
          height: auto;
          display: block;
          object-fit: cover;
          cursor: pointer;
          transition: 0.75s;
        }

        img:hover {
          transform: scale(1.2);
        }

        p {
          z-index: 10;
        }
      }

      .card_items {
        padding: 20px;

        h2 {
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;

          font-size: 18px;
          color: #333333;
          line-height: 23px;
          margin-top: 1rem;

          a {
            cursor: pointer;
            color: #333333;
          }
        }

        span {
          font-weight: 700;
          cursor: pointer;
          text-transform: uppercase;
          font-size: 11.2776px;
          a {
            color: #2253f5;
          }
        }

        p {
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;

          font-size: 13px;
          color: #333333;
          margin-top: 5px;
        }
      }
      @media (max-width: 1030px) {
        flex-direction: column;
        align-items: center;
        margin-right: 40px;
      }

      @media (max-width: 768px) {
        padding-left: 0;
        margin: 3.125rem 0 4rem 0;
        flex-direction: column;
        align-items: center;

        .cardblog {
          margin-bottom: -30px;
        }
      }
    }

    @media (max-width: 768px) {
      h1 {
        max-width: 224px;
        line-height: 1.9rem;
        margin: 0 auto;
        text-align: center;
        font-size: 1.5rem;
      }
    }
  }

  section.partnership {
    padding-top: 100px;
    background-color: white;
    width: 100%;
    padding-bottom: 2rem;

    p {
      width: 270px;
      margin: 0 auto;
      margin-top: 60px;
      margin-bottom: 30px;
      font-family: Montserrat;
      font-size: 16px;

      text-align: center;

      color: #333333;
    }

    h1.partner {
      width: 100%;
      margin: 0 auto;
      font-family: Montserrat;
      font-weight: bold;
      font-size: 38px;
      margin-top: 185px;
      margin-bottom: 130px;

      text-align: center;

      color: #333;
    }

    h1 {
      color: #333;
      font-size: 40px;
      text-align: center;
      margin-bottom: 90px;
    }

    div.tulio {
      display: flex;
      align-items: flex-start;
      width: 340px;
      border: 1px solid #E8EAEF;
      border-radius: 20px;
      display: flex;
      flex-direction: column;
      padding: 30px;

      .author {
        display: flex;
        align-items: center;
        div {
          h2 {
            margin-bottom: 6px;
          }
        }
        div.name {
          margin-left: 20px;

        }
      }

      h2 {
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 700;
        font-size: 16px;
        line-height: 100%;
        color: #333333;
      }

      span {
          font-family: 'Montserrat';
          font-style: normal;
          font-weight: 400;
          font-size: 16px;
          line-height: 100%;
          color: #64728C;
      }

      p {
        font-family: 'Source Sans Pro';
        font-style: normal;
        font-weight: 400;
        font-size: 18px;
        line-height: 140%;
        text-align: left;
        color: #64728c;
        margin: 0;
        margin-bottom: 20px;
        width: unset;
        max-width: unset;
      }

      img {
        border-radius: 50%;
      }

      /* @media (min-width: 769px) and (max-width: 890px) {
        flex-direction: column;
        align-items: center;
        text-align: center;

        h2 {
          margin-top: 18px;
        }
        div {
          margin: 0 !important;
        }
      } */

      @media (max-width: 768px) {
        margin: 0 auto;
      }

    }

    div.steps {
      max-width: 1100px;
      margin: 0 auto;
      width: 100%;
      display: flex;
      justify-content: space-between;
      background: #fff;

      div.card {
        // // width: 330px;
        // // height: 420px;
        image {
          display: block;
          width: auto;
          height: auto;
        }

        padding: 22px;
        background: #f5f8ff;
        position: relative;
        box-shadow: 0px 4px 30px rgba(51, 51, 51, 0.1);
        border-radius: 10px;
        display: flex;
        flex-direction: column;

        .stage {
          width: 48px;
          height: 48px;
          background: linear-gradient(
            154.06deg,
            #fcff7c 47.73%,
            #ffc600 106.67%
          );

          font-family: Montserrat;
          font-weight: bold;
          border-radius: 50%;
          position: absolute;
          top: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 24px;
          top: 180px;
          left: 0;

          &.first {
            left: 23px;
          }

          color: #2253f5;

          filter: drop-shadow(0px 100px 80px rgba(0, 0, 0, 0.07)),
            drop-shadow(0px 41.7776px 33.4221px rgba(0, 0, 0, 0.0503198)),
            drop-shadow(0px 22.3363px 17.869px rgba(0, 0, 0, 0.0417275)),
            drop-shadow(0px 12.5216px 10.0172px rgba(0, 0, 0, 0.035)),
            drop-shadow(0px 6.6501px 5.32008px rgba(0, 0, 0, 0.0282725)),
            drop-shadow(0px 2.76726px 2.21381px rgba(0, 0, 0, 0.0196802));
        }

        h2 {
          font-family: Montserrat;
          font-weight: bold;
          font-size: 24px;
          text-align: center;
          margin-top: 22px;
          color: #2253f5;
        }

        p {
          font-family: Source Sans Pro;
          font-weight: 300;
          font-size: 16px;
          line-height: 24px;
          text-align: center;
          color: #64728c;
          margin-top: 14px;
        }

        img {
          border-radius: 10px;
        }
      }

      @media (max-width: 1030px) {
        flex-direction: column;
        align-items: center;

        .card {
          margin-bottom: 30px;
        }
      }
    }

    @media (max-width: 768px) {
      padding-top: 30px;

      p {
        margin: 0 auto;
        max-width: 200px;
        margin-bottom: 30px;
        font-size: 12px;
        line-height: 1.375rem;
      }

      h1.partner {
        width: unset !important;
        max-width: 212px;
        font-size: 20px;
        line-height: 25px;
        margin: 80px auto 45px;
        color: #333;
      }

      h1 {
        max-width: 160px;
        margin: 0 auto;
        font-size: 20px;
        line-height: 117.6%;
      }

      h2 {
        font-size: 20px !important;
      }
    }
  }

  section.hospedeirosAnonimos {
    background: url('/bgHospedeiros.png') center top / cover repeat #b5abfa !important;

    padding: 43px;

    div {
      max-width: 750px;
      margin: 0 auto;

      display: flex;
      flex-direction: column;
      align-items: center;

      .logos {
        display: flex;
        align-items: flex-start;
        margin-top: 10px;

        .cloudezApresenta {
          width: 207px;
          height: 29px;

          @media (max-width: 768px) {
            width: 20%
            height: 20%
          }
        }

        .hospedeirosLogo {
          width: 552px;
          height: 169px;

          @media (max-width: 768px) {
            width: 100%;
            height: 100%;
          }
        }
      }
      iframe {
        width: 560px;
        height: 310px;
        margin-top: 38px;

        @media (max-width: 768px) {
          width: 100%;
          height: 100%;
        }
      }

      a {
        width: 177px !important;
        margin-top: 38px;

        transition: transform 0.2s;

        &:hover {
          transform: translateY(-4px);
          box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px,
            rgb(51, 51, 51) 0px 4px 0px 0px;
        }
      }

      span {
        font-family: Montserrat;
        font-style: normal;
        font-weight: 300;
        font-size: 16px;
        line-height: 140%;
        

        margin-top: 38px;

        color: #000000;
      }
    }
  }

  section.faq {
    padding: 100px 0;
    background-color: #f5f8ff;

    p {
      width: 270px;
      margin: 0 auto;
      margin-top: 60px;
      margin-bottom: 30px;
      font-family: Montserrat;
      font-size: 16px;

      text-align: center;

      color: #333333;
    }

    h1 {
      color: #333333;
      font-size: 40px;
      text-align: center;
      margin-bottom: 90px;
    }

    div.tabs {
      max-width: 960px;

      margin: 0 auto;

      div {
        div.collapsible {
          box-shadow: 0px 17px 46px rgba(0, 0, 0, 0.07),
            0px 7.10219px 19.2177px rgba(0, 0, 0, 0.0503198),
            0px 3.79717px 10.2747px rgba(0, 0, 0, 0.0417275),
            0px 2.12866px 5.75991px rgba(0, 0, 0, 0.035),
            0px 1.13052px 3.05905px rgba(0, 0, 0, 0.0282725),
            0px 0.470434px 1.27294px rgba(0, 0, 0, 0.0196802);
          border-radius: 10px;
          padding: 22px 18px;
          font-family: Montserrat;
          font-weight: bold;
          font-size: 24px;
          line-height: 140.62%;
          color: #2253f5;
          cursor: pointer;

          &::after {
            content: '+';
            float: right;
            margin-left: 5px;

            font-family: Montserrat;
            font-weight: normal;
            font-size: 24px;
          }

          &.active:after {
            content: '-';
          }
        }

        div.content {
          padding: 0 18px;
          max-height: 0;
          overflow: hidden;
          transition: max-height 0.2s ease-out;

          p {
            padding: 22px 18px;
            font-family: Source Sans Pro;
            font-weight: 300;
            font-size: 16px;
            line-height: 32px;
            width: unset;
            text-align: start;
            margin: 0;

            color: #64728c;
          }
        }
      }

      div.tab {
        background: #ffffff;
        border-radius: 10px;
        margin-bottom: 65px;
      }
    }

    @media (max-width: 768px) {
      padding-top: 45px;

      p {
        max-width: 180px;
        margin: 20px auto;
        font-size: 12px;
        line-height: 18px;
      }

      h1 {
        font-size: 20px;
        margin-bottom: 40px;
        line-height: 25px;
        /* identical to box height, or 125% */

        text-align: center;

        color: #2253f5;
      }
      div.tabs {
        margin: 0 25px;
      }
      div.collapsible {
        font-size: 12px !important;
        line-height: 140.62% !important;
      }
      div.content {
        padding: 0 !important;
        p {
          max-width: unset !important;
          font-size: 12px !important;
          line-height: 18px !important;
        }
      }
    }
  }

  section.cloudezMedia {
    background: linear-gradient(278.18deg, #2253f5 0%, #36a0fc 99.04%);

    div {
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      align-items: center;

      margin: 0 auto;

      padding: 43px;

      max-width: 1300px;

      span {
        font-family: Montserrat;
        font-style: normal;
        font-weight: bold;
        font-size: 32px;
        line-height: 140%;

        color: #ffffff;

        b {
          color: #fcff7c;
        }

        a {
          margin: 0;
        }
      }

      @media (max-width: 768px) {
        flex-direction: column;
        span {
          font-size: 24px;
          text-align: center;
          margin-bottom: 52px;
        }
      }
    }
  }

  footer {
    padding: 60px 20px;
    max-width: 1300px;

    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .logo {
      display: flex;
      flex-direction: column;

      span {
        margin-top: 20px;
        font-family: Source Sans Pro;
        font-size: 18px;
        line-height: 160%;
      }
    }

    .icons {
      img {
        margin-left: 20px;
      }
    }

    @media (max-width: 1250px) {
      max-width: 800px;
    }

    @media (max-width: 768px) {
      flex-direction: column;

      .icons {
        margin-top: 30px;
      }
    }
  }

  button,
  a {
    &.btn {
      cursor: pointer;
      display: block;
      margin: 0 auto;

      background: #fcff7c;
      text-align: center;
      border: none;

      border-radius: 100px;

      font-family: Montserrat;
      font-style: normal;
      font-weight: bold;
      font-size: 16px;
      line-height: 160%;
      color: #2253f5;

      &.outline {
        color: #fcff7c;
        border: 1px solid white;

        background: transparent;
      }

      &.outline-two {
        border: 1px solid white;

        background: transparent;
      }

      &.blue {
        background: #2253f5;
        color: white;
      }

      &.yellowLight {
        background: #f5ffbb;
        color: #000000;
      }

      &.white {
        background: white;
        color: #2253f5;
      }
    }
  }

  a:not(.brazil):not(.usa) {
    width: 270px;
    padding: 10px 0px;
    text-decoration: none;
  }

  button {
    padding: 10px 50px;
  }
`;
